import groq from 'groq';

import { PODCAST_BANNER } from '../blog/podcastBanner';

export const PODCAST_BANNER_BLOCK = groq`
  _type == 'timeline_podcast' => @-> {
    ${PODCAST_BANNER}
  }
`;
